import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

type RootType = {
  clickable?: boolean
}

export const Root = styled.div<RootType>`
  display: flex;
  width: 100%;

  ${({ clickable }) => clickable && `cursor: pointer;`}

  ${({ theme }) => `
    padding: ${theme.space.mobile.small} 0;
  `}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.small} 0;
  `}
`

export const Wrapper = styled.div`
  overflow: hidden;
  flex-grow: 1;
`

export const Sidebar = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-left: ${theme.space.mobile.tiny};
  `}
`

export const Header = styled.div``

export const Content = styled.div``

export const Footer = styled.div``
